<template>
    <div>
        <input type="text">
    </div>
</template>
<script>
export default {
    name: 'MinecraftSearch',
    data() {
        return {
            
        }
    },

}
</script>